$(function(){
  console.log(0)
  $('.tab-content').hide();
  console.log(1)
 $('#tab-1').show();
  console.log(2)
$('#select-box').change(function () {
   dropdown = $('#select-box').val();
  console.log(dropdown);
  $('.tab-content').hide();
  $('#' + "tab-" + dropdown).show();                                    
});
  });